<template>
  <div class="ChangePassword">
    <lm-input
      ref="newPassword"
      label="New password"
      type="password"
      @submit="$emit('submit')"
    />
    <lm-input
      ref="confirmPassword"
      label="Confirm password"
      type="password"
      @submit="$emit('submit')"
    />
    <span v-if="error" class="text-error text-xs">{{ errorMessage }}</span>
  </div>
</template>
<script>
import validate from 'validate.js'
import * as RULES from './validation-rules'
import LmInput from '@/components/form/LmInput.vue'
import FormHelper from './formHelper'

export default {
  name: 'LmChangePassword',
  components: {
    LmInput
  },
  data() {
    return {
      data: '',
      error: false,
      errorMessage: ''
    }
  },
  mounted() {
    this.inputs = [this.$refs.newPassword, this.$refs.confirmPassword]
  },
  methods: {
    validateData() {
      if (!FormHelper.validate(this.inputs)) {
        this.error = true
        return false
      }
      this.clearErrors()
      const password = this.$refs.newPassword.data
      const confirmPassword = this.$refs.confirmPassword.data
      let v = validate({password, confirmPassword}, RULES['changePassword'], {
        fullMessages: false
      })
      if (v === undefined) {
        this.data = password
        return true
      }
      this.error = true
      this.errorMessage = v.confirmPassword[0]
      return false
    },
    clearErrors() {
      this.error = false
      this.errorMessage = ''
      FormHelper.clearErrors(this.inputs)
    },
    reset() {
      this.data = ''
      this.clearErrors()
      FormHelper.reset(this.inputs)
    }
  }
}
</script>
